import { useThemeStore } from "@stores/theme.store";
import { Select } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { linkPage } from "@utils/router";
import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { FinanceService } from "@services/finance.service";
import { VirtualAccountReport } from "@services/dtos/finance.dto";
import { FcFinePrint } from "react-icons/fc";
import { Spiner } from "@components/loaders/spiner";
import { toRp } from "@utils/helper";
import moment from "moment-timezone";
moment.locale("id");

export const VaDataPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar, setBottomNavigation } = useThemeStore(
    (state) => state
  );
  const [limit, setLimit] = useState<string>("10");

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [FinanceService.queries.GET_FINANCE_BILLS_PAID_OF, nis, limit],
    queryFn: () => FinanceService.virtualAccountReport({ nis, limit }),
  });

  const onOpenDetail = (dataPayment: VirtualAccountReport) => {
    navigate(linkPage.VA_DETAIL_PAGE, { state: dataPayment });
  };

  useEffect(() => {
    setAppBar({ title: "Laporan VA", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Laporan VA",
    });
    setBottomNavigation("home");
  }, [setHeader, setAppBar, setBottomNavigation]);

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <>
          <div className="tw-bg-other-100 tw-rounded-lg card-body">
            <div className="tw-text-xs tw-mb-1">Filter Data</div>
            <Select
              className="tw-border-other-0 tw-text-base"
              placeholder="Pilih Jumlah Ditampilkan"
              defaultValue={limit}
              style={{ width: "100%" }}
              allowClear
              onChange={(e) => setLimit(e)}
              options={[
                { value: "10", label: "10" },
                { value: "25", label: "25" },
                { value: "50", label: "50" },
                { value: "100", label: "100" },
              ]}
            ></Select>
            <p className="tw-mt-3 tw-text-sm">
              Data yang ditampilkan {limit} data terakhir
            </p>
          </div>

          <div className="tw-bg-other-100 tw-rounded-lg card-body tw-mt-3">
            {isPending ? (
              <div className="tw-text-center">
                <Spiner />
              </div>
            ) : data?.data != null && data.data.length > 0 ? (
              <>
                {data.data.map((item, idx) => (
                  <div
                    key={idx}
                    className="tw-border-solid tw-border-x-0 tw-border-y-1 tw-border-y-other-200 tw-py-1 tw-mb-0.5"
                    onClick={() => onOpenDetail(item)}
                  >
                    <div className="tw-px-2 tw-flex tw-justify-between tw-items-center tw-font-semibold">
                      <div className="tw-text-xs tw-font-medium tw-text-other-600">
                        Exp:{" "}
                        {moment(item.vaDateExpired ?? Date.now()).format(
                          "DD MMMM YYYY || HH:mm"
                        )}
                      </div>
                      <div className="tw-w-1/3 tw-flex tw-justify-end">
                        {item.vaStatus === "PENDING" ? (
                          <span className="tw-inline-flex tw-items-center tw-rounded-md tw-bg-yellow-50 tw-px-2 tw-py-1 tw-text-[10px] tw-font-medium tw-text-yellow-700 tw-ring-1 tw-ring-yellow-600/10 tw-ring-inset">
                            PENDING
                          </span>
                        ) : item.vaStatus === "EXPIRED" ? (
                          <span className="tw-inline-flex tw-items-center tw-rounded-md tw-bg-red-50 tw-px-2 tw-py-1 tw-text-[10px] tw-font-medium tw-text-red-700 tw-ring-1 tw-ring-red-600/10 tw-ring-inset">
                            EXPIRED
                          </span>
                        ) : (
                          <span className="tw-inline-flex tw-items-center tw-rounded-md tw-bg-green-50 tw-px-2 tw-py-1 tw-text-[10px] tw-font-medium tw-text-green-700 tw-ring-1 tw-ring-green-600/10 tw-ring-inset">
                            COMPLETE
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="tw-px-2 tw-flex tw-justify-between tw-items-center tw-font-semibold">
                      <div className="tw-text-sm">{item.vaTrxId}</div>
                      <div className="tw-w-1/2 tw-text-end">
                        <div className="tw-text-sm">
                          {toRp((item.vaTrxAmount ?? 0) + 2000)}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="tw-p-8 tw-text-center">
                <FcFinePrint size={50} />
                <div>Data tidak ditemukan</div>
              </div>
            )}
          </div>
        </>
      </div>
    </>
  );
};
